











































































































































/** @format */

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { IZhaohangData, zhaohangDataDefault } from './type';

@Component({
  components: {}
})
export default class ZhaohangPay extends Vue {
  @Prop()
  dataOrigin!: any;

  @Prop({ type: Boolean, default: false })
  isDisabled!: boolean;

  // @Prop({ type: Boolean, default: false })
  // isReset!: boolean

  formData: IZhaohangData = zhaohangDataDefault;

  // 初始化赋值
  @Watch('dataOrigin', { immediate: true })
  dataOriginChange(newVal: any) {
    const {
      id = '',
      cmbAppId = '',
      cmbAppKey = '',
      wxAppId = '',
      wxMchId = '',
      wxApiKey = '',
      wxAppSecret = '',
      aliAppId = '',
      aliPartnerId = '',
      aliRsaPrivateKey = '',
      aliPublicKey = '',
      chkAccount = '',
      chkPassword = ''
    } = newVal;
    this.formData = {
      id,
      cmbAppId,
      cmbAppKey,
      wxAppId,
      wxMchId,
      wxApiKey,
      wxAppSecret,
      aliAppId,
      aliPartnerId,
      aliRsaPrivateKey,
      aliPublicKey,
      chkAccount,
      chkPassword
    };
  }

  @Watch('formData', { deep: true })
  formDataChange(newVal: IZhaohangData) {
    this.$emit('change', newVal);
  }

  // 生命周期初始化
  async created() {}
}
